(() => {
  if (!document.querySelector('.digi-packs-aug')) return;

  initCountdown(document);
  initRails(document);
  initBeforeAfter(document);
  initFaq(document);
  initSticky(document);

  function initCountdown(scope) {
    const el = scope.querySelector('[data-countdown]');
    if (!el) return;
    const iso = el.dataset.targetIso || '';
    const pinned = /[zZ]|[+-]\d{2}:?\d{2}$/.test(iso) ? iso : iso + '+10:00';
    const target = new Date(pinned).getTime();
    if (Number.isNaN(target)) return;
    const cells = {
      days: el.querySelector('[data-unit="days"]'),
      hours: el.querySelector('[data-unit="hours"]'),
      mins: el.querySelector('[data-unit="mins"]'),
      secs: el.querySelector('[data-unit="secs"]'),
    };
    const tick = () => {
      const diff = Math.max(0, target - Date.now());
      const s = Math.floor(diff / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = s % 60;
      cells.days && (cells.days.textContent = pad(d));
      cells.hours && (cells.hours.textContent = pad(h));
      cells.mins && (cells.mins.textContent = pad(m));
      cells.secs && (cells.secs.textContent = pad(sec));
    };
    tick();
    setInterval(tick, 1000);
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initRails(scope) {
    scope.querySelectorAll('.dpa-rail').forEach(setupRail);
  }

  function setupRail(rail) {
    const items = rail.querySelectorAll('.dpa-rail__item');
    if (items.length < 2) return;

    const dots = document.createElement('div');
    dots.className = 'dpa-rail-dots dpa-rail-dots--hidden';
    dots.setAttribute('role', 'tablist');
    rail.insertAdjacentElement('afterend', dots);

    let dotEls = [];
    let pages = 0;

    const buildDots = (n) => {
      dots.replaceChildren();
      dotEls = [];
      for (let i = 0; i < n; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dpa-rail-dot' + (i === 0 ? ' dpa-rail-dot--active' : '');
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        btn.addEventListener('click', () => {
          const max = rail.scrollWidth - rail.clientWidth;
          const target = pages <= 1 ? 0 : (i / (pages - 1)) * max;
          rail.scrollTo({ left: target, behavior: 'smooth' });
        });
        dots.appendChild(btn);
        dotEls.push(btn);
      }
    };

    const update = () => {
      if (!pages) return;
      const max = rail.scrollWidth - rail.clientWidth;
      const ratio = max > 0 ? rail.scrollLeft / max : 0;
      const idx = Math.min(pages - 1, Math.max(0, Math.round(ratio * (pages - 1))));
      dotEls.forEach((d, i) => d.classList.toggle('dpa-rail-dot--active', i === idx));
    };

    const recalc = () => {
      const scrollable = rail.scrollWidth - rail.clientWidth > 1;
      if (!scrollable) {
        pages = 0;
        dots.classList.add('dpa-rail-dots--hidden');
        return;
      }
      const next = Math.max(2, Math.ceil(rail.scrollWidth / rail.clientWidth));
      if (next !== pages) { pages = next; buildDots(pages); }
      dots.classList.remove('dpa-rail-dots--hidden');
      update();
    };

    let raf = 0;
    rail.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; update(); });
    }, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(recalc).observe(rail);
    window.addEventListener('resize', recalc);
    recalc();

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (rail.scrollWidth - rail.clientWidth > 1) nudge(rail);
          io.disconnect();
        }
      });
    }, { threshold: 0.4 });
    io.observe(rail);
  }

  function nudge(rail) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const w = rail.clientWidth;
    const step = Math.max(60, Math.round(w * 0.18));
    try {
      rail.scrollTo({ left: step, behavior: 'smooth' });
      setTimeout(() => rail.scrollTo({ left: 0, behavior: 'smooth' }), 550);
    } catch (_) {}
  }

  function initBeforeAfter(scope) {
    const ba = scope.querySelector('[data-ba]');
    if (!ba) return;
    let dragging = false;

    const set = (pct) => {
      const p = Math.max(0, Math.min(100, pct));
      ba.style.setProperty('--dpa-ba-cut', (100 - p) + '%');
      ba.style.setProperty('--dpa-ba-pos', p + '%');
      ba.dataset.baPos = String(Math.round(p));
    };
    set(50);

    const posFromEvent = (ev) => {
      const rect = ba.getBoundingClientRect();
      const x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - rect.left;
      return (x / rect.width) * 100;
    };

    const onDown = (ev) => {
      dragging = true;
      set(posFromEvent(ev));
      ev.preventDefault();
    };
    const onMove = (ev) => { if (dragging) set(posFromEvent(ev)); };
    const onUp = () => { dragging = false; };

    ba.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  }

  function initFaq(scope) {
    const faq = scope.querySelector('[data-faq]');
    if (!faq) return;
    const items = faq.querySelectorAll('.dpa-faq__item');
    items.forEach((item) => {
      const btn = item.querySelector('.dpa-faq__q');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const open = item.getAttribute('aria-expanded') === 'true';
        items.forEach((i) => i.setAttribute('aria-expanded', 'false'));
        if (!open) item.setAttribute('aria-expanded', 'true');
      });
    });
  }

  function initSticky(scope) {
    const bar = scope.querySelector('[data-sticky]');
    const packs = scope.querySelector('#dpa-packs');
    if (!bar || !packs) return;
    const onScroll = () => {
      const rect = packs.getBoundingClientRect();
      const show = rect.bottom < window.innerHeight * 0.6;
      bar.setAttribute('data-show', show ? 'true' : 'false');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
})();
